<template>
  <div
    class="detailWrap"
    :style="{ backgroundImage: 'url(' + userDetail.sharePicture + ')' }"
  >
    <div class="detailMain">
      <div class="detailTitle">{{ userDetail.subtitle }} 候选人</div>
      <detail :userDetail="userDetail" :winnerIco="winnerIco"></detail>
      <div class="tc" v-if="clientType != 'typePC'">
        <span class="voteBtn" @click="hanldVote" v-if="btnStatus === '1'">{{
          btnTxt
        }}</span>
        <span class="voteBtn disabled" v-else>{{ btnTxt }}</span>
      </div>
    </div>
    <footerbar></footerbar>
  </div>
</template>
<script>
// import topbar from "@/components/comm/topbar.vue";
import { getSignature } from "@/utils/wxShare";
import axios from "axios";
import detail from "@/components/detail/detail.vue";
import footerbar from "@/components/detail/footerbar.vue";
import { getUrlPara } from "@/assets/js/voteComm.js";
import {
  getClient,
  hanldAndroidVote,
  // fromAndroidStatus,
} from "@/utils/bridge.js";

import { Toast } from "vant";

export default {
  name: "vote",
  components: {
    detail,
    footerbar,
  },
  data() {
    return {
      userDetail: {},
      urlId: "",
      winnerIco: false,
      clientType: "",
      btnShow: true, //投票按钮是否显示
      btnTxt: "投票", //投票按钮默认显示文字
      btnStatus: "", //1可投 2 已投 3 过期
      hanldVoteTxt: "", //哪个平台触发的投票
    };
  },
  methods: {
    //获取数据
    getDatalist() {
      let url = `/api/spec/share/userCandidateDetail/${this.urlId}`;
      axios
        .get(url)
        .then((res) => {
          // console.log(res);
          this.userDetail = res.data.data;
          this.userDetail.introduction = this.userDetail.introduction.replace(
            /[\n\r]/g,
            "<br>"
          );
          let dataForWeixin = {
            title: `${this.userDetail.username}正在第一视频参与投票，快来为他/她投一票吧！`,
            desc: this.userDetail.subtitle,
            imgUrl: this.userDetail.avatar,
          };
          // console.log(dataForWeixin);
          getSignature(dataForWeixin);
        })
        .catch((err) => {
          console.log(err);
          Toast.fail("请求错误，请联系管理员");
        });
    },
    //点击投票按钮事件
    hanldVote() {
      //h5->IOS交互
      if (this.clientType === "typeIos") {
        window.webkit.messageHandlers.iOSHandler.postMessage({
          type: "voteActionInH5",
        });
      }
      //h5->Android交互
      if (this.clientType === "typeAndroid") {
        hanldAndroidVote();
        // this.hanldVoteTxt = hanldAndroidVote();
      }
    },
    //IOS往H5传值，1可投 2 已投 3 过期
    fromIospara(iosPara) {
      // iosPara = { status: "3" };
      this.btnStatus = iosPara.status;
      this.btntxtShow();
    },
    btntxtShow() {
      if (this.btnStatus == "1") {
        this.btnTxt = "投票";
      }
      if (this.btnStatus == "2") {
        this.btnTxt = "已投";
      }
      if (this.btnStatus == "3") {
        this.btnTxt = "已过期";
      }
    },
  },
  created() {
    this.urlId = getUrlPara("id");
    this.getDatalist();
    this.clientType = getClient(); //判断平台类型
    //从安卓获取按钮状态
    //自定义JS注册事件监听 connectWebViewJavascriptBridge 方法名可改
    function connectWebViewJavascriptBridge(callback) {
      console.log("自定义JS注册事件监听 connectWebViewJavascriptBridge 方法");
      if (window.WebViewJavascriptBridge) {
        callback(WebViewJavascriptBridge);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          function () {
            callback(WebViewJavascriptBridge);
          },
          false
        );
      }
    }
    if (this.clientType === "typeAndroid") {
      var that = this;
      // this.btnStatus = fromAndroidStatus().status;
      //注册回调函数，第一次连接时调用 初始化函数 connectWebViewJavascriptBridge和上面一致
      connectWebViewJavascriptBridge(function (bridge) {
        //初始化 必须有 Android 通过 JSBridge 调用 默认JS bridge.init bridgeWebView.send调用
        bridge.init(function (message, responseCallback) {
          var data = {
            "Javascript Responds": "Android调用JS初始化方法!",
          };
          responseCallback(data);
        });

        //Android调用js方法：functionInJs方法名称需要保持一致 ，并返回给Android通知
        bridge.registerHandler(
          "fromAndroid",
          function (data, responseCallback) {
            // alert("JS接收到Android数据弹JS对话框：" + data);
            //希望data格式是：{ status: "3" }，//1可投 ， 2 已投 ， 3 过期
            that.btnStatus = JSON.parse(data).status;
            that.btntxtShow();
            var data2 = "";
            var responseData = data2;
            responseCallback(responseData);
          }
        );
      });
    }
  },
  mounted() {
    // 将fromIospara方法绑定到window下面，提供给外部调用
    window["fromIospara"] = (iosPara) => {
      this.fromIospara(iosPara);
    };
    // window.Vue = this;
  },
};
</script>
<style scoped>
.test {
  margin: -50px 20px 20px 20px;
  padding: 10px;
  border: #fff 2px solid;
  line-height: 20px;
  color: #fff;
  font-size: 14px;
}
</style>